module.exports = __webpack_public_path__ + "img/logo-bitfury.3c1065cc.png";